<template>
  <b-modal
    id="update-company-name"
    ref="update-company-name"
    size="xs-size"
    title="Update Company Name"
    modal-class="update-user-details-modal"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">{{ label.get("update_company_name") }}</h2>
    </div>
    <div class="details-form">
      <div class="content-wrapper">
        <div class="form-row">
          <label>{{ label.get("company_name") }}</label>
          <div class="input-wrapper">
            <input
              ref="companyName"
              v-model="company_name"
              type="text"
              maxlength="50"
              :class="{ error: hasError }"
              autofocus
              @keydown.enter="changeName"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="atto-btn cancel" @click="close">
          {{ label.get("cancel") }}
        </button>
        <button :disabled="disabledSubmitButton" type="submit" class="atto-btn submit" @click="changeName">
          {{ label.get("update") }}
        </button>
        <span
          v-if="hasError && !$v.company_name.required"
          class="error-message"
        >
          {{ label.get("please_enter_a_name_for_your_company") }}
        </span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";
import { required } from "vuelidate/lib/validators";

export default {
  name: "UpdateCompanyNameComponent",
  data() {
    return {
      disabledSubmitButton: false,
      company_name: this.$store.state.company.name,
      originalName: this.$store.state.company.name,
      hasError: false,
    };
  },
  validations: {
    company_name: {
      required,
    },
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["update-company-name"].show();
  },
  methods: {
    close() {
      this.$root.$emit("hideUpdateCompanyName");
    },
    changeName: function() {
      this.$v.company_name.$touch();
      if (this.$v.company_name.$invalid) {
        this.hasError = true;
        return false;
      }
      this.hasError = false;

      if (this.company_name !== this.$store.state.company.name) {
        const params = {
          name: this.company_name,
        };
        this.disabledSubmitButton = true;
        CompanyService.updateCompanyName(params)
          .then((response) => {
            this.hasError = false;
            this.$store.state.company.name = this.company_name;
            this.$awn.success(response.data.message);
            this.$root.$emit("hideUpdateCompanyName");
          })
          .catch((error) => {
            this.disabledSubmitButton = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.details-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;

  .form-row {
    display: flex;
    flex-direction: column;
    margin: 0 0 8px 0;

    .new-pass {
      .input-wrapper {
        margin-right: 40px;
      }
    }

    label {
      display: inline-flex;
      font-size: 0.6875rem;
      line-height: 0.8125rem;
      font-family: $roboto-font;
      font-weight: $roboto-medium;
      color: #999999;
      letter-spacing: 0.6px;
      text-transform: uppercase;
      margin-bottom: 4px;
    }

    .input-wrapper {
      display: flex;
      width: 100%;
      position: relative;
      flex-direction: row;
      padding: 10px 0 10px 12px;
      border: 2px solid #efefef;
      height: 40px;

      input {
        flex-grow: 1;
        border: 0;
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-family: $roboto-font;
        font-weight: 400;
        color: $atto-font-color;
        @include style-placeholder(#999);
      }

      i.tick {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
      }

      &:focus-within {
        border-color: #00b9cb;
      }

      &.has-error {
        border-color: #e05656;
      }
    }

    .error-message {
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      color: #e05656;
    }

    &.row-align {
      flex-direction: row;

      .col {
        padding: 0;
      }
    }

    &.submit-wrap {
      margin-top: 28px;
      margin-bottom: 0;
    }

    .submit-form {
      width: 320px;
      max-width: 100%;
      justify-content: center;
      text-transform: uppercase;
    }
  }
  .modal .modal-content .modal-body .content-wrapper {
    padding: 16px 40px 24px 40px;
  }
}
</style>
